import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function OfferSection() {
  return <section className="py-24 bg-[#FDF6F0] relative overflow-hidden" data-id="element-135">
      {/* Decorative shapes */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-[#C97B63] opacity-10 rounded-full blur-2xl" data-id="element-136"></div>
      <div className="absolute bottom-10 right-10 w-48 h-48 bg-[#1A5C4C] opacity-10 rounded-full blur-2xl" data-id="element-137"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-3xl md:text-5xl font-serif text-[#1A5C4C] mb-6" data-id="element-140">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>
          <p className="text-xl text-[#2A2A2A] mb-12 max-w-2xl mx-auto" data-id="element-141">
            No esperes a que tu ropa deje de quedarte por completo.
          </p>

          <div id="precio" className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-[#1A5C4C]/10 max-w-2xl mx-auto" data-id="element-142">
            <p className="text-lg text-[#2A2A2A] mb-4" data-id="element-143">
              El protocolo completo <strong data-id="element-144">Metabolismo 45+ Reset</strong> tiene
              un valor regular de{' '}
              <span className="line-through text-gray-400" data-id="element-145">$67</span>, pero
              puedes obtenerlo hoy por un pago único de acceso inmediato.
            </p>

            <div className="my-8 py-6 border-y border-gray-100" data-id="element-146">
              <span className="inline-block bg-[#C97B63] text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-3" data-id="element-147">
                🔥 Descuento Promocional
              </span>
              <br data-id="element-148" />
              <span className="block text-sm font-bold text-[#C97B63] uppercase tracking-widest mb-2" data-id="element-149">
                Precio Especial por Tiempo Limitado
              </span>
              <span className="text-6xl font-serif text-[#1A5C4C] font-bold" data-id="element-150">
                $6.36{' '}
                <span className="text-2xl text-gray-500 font-sans" data-id="element-151">USD</span>
              </span>
              <p className="text-sm text-[#C97B63] mt-2 font-semibold" data-id="element-152">
                ¡Ahorras más del 90% con esta promoción!
              </p>
            </div>

            <Button fullWidth className="mb-4" href="https://buenavibrax.com/cart/45581048184889:1" data-id="element-153">
              ¡Quiero mi reset metabólico ahora!
            </Button>

            <p className="text-sm text-gray-500 flex items-center justify-center mt-4" data-id="element-154">
              <span className="mr-2" data-id="element-155">🔒</span> Acceso inmediato en PDF. Pago
              seguro y cifrado.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}